/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import actions from "./actions"

const state = {
	clients: [],
}

const getters = {
	getClients: state => state.clients,
}

const mutations = {
	SET_CLIENT_LIST(state, clients) {
		state.clients = clients;
	},
	UPDATE_CLIENT(state, client) {
		let index = state.clients.findIndex(clientLocal => clientLocal.id == client.id)
		if(index >= 0){
			// Vue.set(state.clients, index, client)
			state.clients[index] = client
		} else {
			state.clients.push(client)
		}
	},
	DELETE_CLIENT(state, client) {
		let index = state.clients.findIndex(clientLocal => clientLocal.id == client.id)
		if(index >= 0){
			state.clients.splice(index, 1)
		}
	},
}
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
